export class TooltipType {
    static DEFAULT = "default";
    static GANT = "gant";
    static COMPONENT_ROW = "component-row";
    static ACTUALS = 'actuals';
}